import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import ReactApexChart from 'react-apexcharts';

import { Box, Flex, Text } from '@chakra-ui/react';

import { apiService } from '../../../../services/ApiService';

import Card from '../../../../components/Card/Card';
import CardBody from '../../../../components/Card/CardBody';
import RangeSelect from './RangeSelect';
import { createAreaChartOptions } from './chartOptions';

function AvgCheckChart() {
  const [period, setPeriod] = useState('year');

  const { data: chart = [], isLoading } = useQuery({
    queryKey: ['avg-check-chart', period],
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: async () => {
      const response = await apiService.getStatsAvgCheck({
        range: period,
      });

      return response.data;
    },
  });

  const series = useMemo(
    () => [
      {
        name: 'Average Check',
        data: chart.map((item) => item.amount),
      },
    ],
    [chart],
  );

  const options = useMemo(
    () =>
      createAreaChartOptions({
        color: '#57D175',
        categories: chart.map((i) => new Date(i.date).toISOString()),
        yFormatter: (v) => `$${v.toFixed(0)}`,
        tooltipFormatter: (v) => `$${v.toFixed(2)}`,
      }),
    [chart],
  );

  return (
    <Card minH={301} padding="24px 16px 12px 16px" w="100%">
      <Flex justifyContent="center" mb="12px">
        <Text variant="title-lg">Average Check</Text>
      </Flex>

      <RangeSelect period={period} setPeriod={setPeriod} />

      <CardBody w="100%" padding="0">
        <Box w="100%">
          {isLoading ? (
            <Flex justifyContent="center" alignItems="center" height="315px">
              <Text>Loading chart data...</Text>
            </Flex>
          ) : (
            <ReactApexChart
              options={options}
              series={series}
              type="area"
              height={300}
              className="full-width-members-dashboard-chart"
            />
          )}
        </Box>
      </CardBody>
    </Card>
  );
}

export default AvgCheckChart;
